import { USER_DASHBOARD,NOTIFICATION_COUNT,NEWORDER_COUNT,RECEIVEDORDER_COUNT,RECEIVED_RIDE_COUNT } from "./actionTypes";

export const fetchUserdashboard = (userdashboard) => async (dispatch) => {
  dispatch({
    type: USER_DASHBOARD,
    userdashboard: userdashboard,
  });
};

export const updateNotifictioncount = (count) => async (dispatch) => {
  dispatch({
    type: NOTIFICATION_COUNT,
    notificationcount: count,
  });
};

export const newOrdercount = (count) => async (dispatch) => {
  dispatch({
    type: NEWORDER_COUNT,
    new_orders: count,
  });
};

export const receivedOrdercount = (count) => async (dispatch) => {
  dispatch({
    type: RECEIVEDORDER_COUNT,
    receivedordercount: count,
  });
};

export const receivedRidecount = (count) => async (dispatch) => {
   dispatch({
      type:RECEIVED_RIDE_COUNT,
      receivedRidecount:count
   })
}
